import { Navigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../../context/auth";
import { isAppLocal } from "../../../helpers/methods";

const RedirectLoginRoute = () => {
    const { redirectToMyHome } = useAuth();
    const location = useLocation();
    const from = location?.state?.from || "/";
    return isAppLocal() ? (
        <Navigate to={"/external_login/"} state={{ from: from }} replace />
    ) : (
        redirectToMyHome(true)
    );
};

export default RedirectLoginRoute;
